import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { doLogOut } from '../actions/login.js';
import { Menu } from '../components/Menu/Menu.js'

class MenuContainer extends Component {
    render() {
        return <Menu 
            doLogOut={this.props.doLogOut}
            user={this.props.user}
            sessions={this.props.sessions}
            proposals={this.props.proposals}
            breadcrumbsList={this.props.breadcrumbsList}
            application={this.props.application}
            jobs={this.props.jobs}
            configuration={this.props.configuration}
            >
        </Menu>;
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,      
        sessions : state.sessions,
        proposals : state.proposals,
        breadcrumbsList: state.breadcrumbsList,
        application : state.application,
        jobs : state.jobs,
        configuration : state.configuration
      
    };
}

function mapDispatchToProps(dispatch) {
    return {
        doLogOut: bindActionCreators(doLogOut, dispatch)
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MenuContainer);


// WEBPACK FOOTER //
// ./src/containers/MenuContainer.js